// extracted by mini-css-extract-plugin
export var divider = "_dj-7";
export var itemsToggle = "_dj-8";
export var mergeModal = "_dj-1";
export var optionCard = "_dj-4";
export var radioGroup = "_dj-6";
export var radioOption = "_dj-0";
export var selected = "_dj-5";
export var shipmentOptions = "_dj-2";
export var tableOptions = "_dj-3";